import PropTypes from 'prop-types';

const locationShape = PropTypes.shape({
  name: PropTypes.string,
  imageUrl: PropTypes.string,
});

export default locationShape;
